<template>
  <div class="copyright-page">
    <div class="container">
      <section class="copyright-hero">
        <div>
          <p class="eyebrow">COPYRIGHT NOTICE</p>
          <h1>版权声明</h1>
          <p class="lead">道晗漫画平台尊重创作者和权利人的合法权益，持续完善作品来源标识、内容审核和侵权投诉处理机制。</p>
        </div>
        <div class="hero-mark" aria-hidden="true">©</div>
      </section>

      <div class="copyright-layout">
        <div class="copyright-main">
          <section class="copyright-card" id="policy">
            <p class="section-kicker">01 / POLICY</p>
            <h2>网站版权政策</h2>
            <p>道晗漫画平台尊重并保护著作权。平台展示的作品，优先来源于版权方、代理方或合作方的授权；部分内容由用户依照平台规则上传。作品详情页会尽量标注版权归属与授权信息，具体权利仍以权利人及相关授权文件为准。</p>
            <p>未经权利人许可，任何单位或个人不得复制、转载、改编、传播或将平台内容用于商业用途。用户通过平台获得的阅读权限，不等于获得作品的著作权或再授权权。</p>
          </section>

          <section class="copyright-card" id="source">
            <p class="section-kicker">02 / SOURCE</p>
            <h2>内容来源说明</h2>
            <div class="source-list">
              <article class="source-item">
                <span class="source-index">A</span>
                <div>
                  <h3>授权内容</h3>
                  <p>由版权方、代理方或合作方提供，并根据授权范围展示。作品详情页的授权类型、期限和脱敏编号用于辅助识别。</p>
                </div>
              </article>
              <article class="source-item">
                <span class="source-index">B</span>
                <div>
                  <h3>用户上传内容</h3>
                  <p>用户上传内容应当拥有合法来源或相应授权，不得侵犯他人的著作权、商标权、肖像权及其他合法权益。</p>
                </div>
              </article>
              <article class="source-item">
                <span class="source-index">C</span>
                <div>
                  <h3>平台处理</h3>
                  <p>平台会根据投诉材料和核验结果，对涉嫌侵权内容采取限制展示、下架、屏蔽或进一步核查等处理措施。</p>
                </div>
              </article>
            </div>
          </section>

          <section class="copyright-card complaint-card" id="complaint">
            <p class="section-kicker">03 / COMPLAINT</p>
            <h2>侵权投诉</h2>
            <p>如果您认为平台展示的内容侵犯了您的合法权益，请通过以下方式联系我们。为了便于核验，请尽量提供权利证明、投诉人身份及联系方式、涉嫌侵权内容的具体页面链接，以及明确的处理诉求。</p>
            <div class="complaint-contact">
              <div>
                <span>受理主体</span>
                <strong>北京道晗科技有限责任公司</strong>
              </div>
              <div>
                <span>投诉电话</span>
                <a href="tel:15311160987">15311160987</a>
              </div>
              <div class="wide">
                <span>联系地址</span>
                <strong>北京市朝阳区豆各庄黄厂西路1号C5栋五层5365</strong>
              </div>
            </div>
            <p class="complaint-note">提交投诉后，平台将结合材料进行核验，并依据适用规则处理。恶意投诉、虚假投诉或重复提交无关材料，可能影响受理效率。</p>
          </section>
        </div>

        <aside class="copyright-aside">
          <div class="aside-card">
            <p class="section-kicker">QUICK ACCESS</p>
            <h2>需要帮助？</h2>
            <p>查看作品页的授权标识，了解平台的版权处理方式。</p>
            <router-link class="aside-link secondary" to="/about">了解平台主体</router-link>
          </div>
          <div class="aside-card aside-meta">
            <span>声明版本</span>
            <strong>2026.08</strong>
            <small>最后更新：2026年8月17日</small>
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyrightPage'
}
</script>

<style scoped>
.copyright-page {
  min-height: 100vh;
  padding: 34px 0 58px;
  background:
    radial-gradient(circle at 8% 0%, rgba(255, 204, 102, 0.12), transparent 28%),
    radial-gradient(circle at 92% 12%, rgba(35, 211, 238, 0.1), transparent 30%),
    linear-gradient(180deg, rgba(7, 9, 18, 0.14), rgba(7, 9, 18, 0.62));
}

.container {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
}

.copyright-hero,
.copyright-card,
.aside-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(20, 24, 39, 0.94), rgba(10, 13, 24, 0.96));
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.28);
}

.copyright-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 34px 36px;
  margin-bottom: 24px;
}

.eyebrow,
.section-kicker {
  margin: 0 0 8px;
  color: #23d3ee;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.12em;
}

.copyright-hero h1 {
  color: #f8fbff;
  font-size: 42px;
  line-height: 1.1;
}

.lead {
  max-width: 760px;
  margin: 14px 0 0;
  color: #aab5d4;
  font-size: 16px;
  line-height: 1.85;
}

.hero-mark {
  display: grid;
  flex: 0 0 94px;
  width: 94px;
  height: 94px;
  place-items: center;
  border: 1px solid rgba(35, 211, 238, 0.35);
  border-radius: 50%;
  color: #ffcc66;
  font-size: 56px;
  font-weight: 800;
  background: radial-gradient(circle, rgba(35, 211, 238, 0.18), rgba(255, 204, 102, 0.04) 70%);
}

.copyright-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 286px;
  gap: 24px;
  align-items: start;
}

.copyright-main {
  display: grid;
  gap: 24px;
}

.copyright-card,
.aside-card {
  padding: 28px 30px;
}

.copyright-card h2,
.aside-card h2 {
  margin: 0 0 16px;
  color: #f8fbff;
  font-size: 26px;
}

.copyright-card > p:not(.section-kicker),
.aside-card > p:not(.section-kicker) {
  margin: 0 0 14px;
  color: #aab5d4;
  font-size: 15px;
  line-height: 1.9;
}

.source-list {
  display: grid;
  gap: 12px;
  margin-top: 20px;
}

.source-item {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 14px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.045);
}

.source-index {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 8px;
  color: #07101d;
  font-size: 13px;
  font-weight: 900;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.source-item h3 {
  margin: 0 0 5px;
  color: #f5f7ff;
  font-size: 17px;
}

.source-item p {
  margin: 0;
  color: #aab5d4;
  font-size: 14px;
  line-height: 1.75;
}

.complaint-card {
  scroll-margin-top: 24px;
}

.complaint-contact {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 20px 0 16px;
}

.complaint-contact > div {
  display: grid;
  gap: 7px;
  padding: 15px 16px;
  border: 1px solid rgba(35, 211, 238, 0.14);
  border-radius: 9px;
  background: rgba(35, 211, 238, 0.05);
}

.complaint-contact .wide {
  grid-column: span 2;
}

.complaint-contact span,
.aside-meta span {
  color: #23d3ee;
  font-size: 12px;
}

.complaint-contact strong,
.complaint-contact a,
.aside-meta strong {
  color: #f5f7ff;
  font-size: 15px;
  line-height: 1.55;
}

.complaint-contact a {
  text-decoration: none;
}

.complaint-contact a:hover,
.aside-link:hover {
  color: #ffcc66;
}

.complaint-note {
  margin: 0 !important;
  color: #7683a1 !important;
  font-size: 13px !important;
}

.copyright-aside {
  display: grid;
  gap: 16px;
  position: sticky;
  top: 24px;
}

.aside-card {
  padding: 22px;
}

.aside-card h2 {
  font-size: 22px;
}

.aside-link {
  display: block;
  padding: 12px 14px;
  border-radius: 8px;
  color: #07101d;
  font-size: 14px;
  font-weight: 900;
  text-decoration: none;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.aside-link.secondary {
  margin-top: 10px;
  color: #dfe7ff;
  text-align: center;
  background: rgba(255, 255, 255, 0.08);
}

.aside-meta {
  display: grid;
  gap: 6px;
}

.aside-meta strong {
  font-size: 24px;
}

.aside-meta small {
  color: #7683a1;
  font-size: 12px;
}

@media (max-width: 880px) {
  .copyright-layout {
    grid-template-columns: 1fr;
  }

  .copyright-aside {
    position: static;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 620px) {
  .copyright-page {
    padding-top: 20px;
  }

  .container {
    padding: 0 16px;
  }

  .copyright-hero {
    align-items: flex-start;
    padding: 24px 20px;
  }

  .copyright-hero h1 {
    font-size: 34px;
  }

  .hero-mark {
    flex-basis: 62px;
    width: 62px;
    height: 62px;
    font-size: 38px;
  }

  .copyright-card {
    padding: 22px 20px;
  }

  .copyright-aside,
  .complaint-contact {
    grid-template-columns: 1fr;
  }

  .complaint-contact .wide {
    grid-column: auto;
  }
}
</style>
